const status = {
  SUCCESS: 'success',
  FAIL: 'fail',
  IDLE: 'idle',
  PROGRESS: 'progress',
};

export default status;
